import { getBizEntityUrl } from "../utils";

export const DataStory = {
  attributes: {},
  requestUrls: {
    dataStoryList: getBizEntityUrl("dataStory/v1?*")
  },
  requestKeysToIgnoreIntercept: [""]
};
